<template>
  <div id="container" class="container" @contextmenu="preventContextmenu" @copy="preventCopy" @mouseup="handleMouseUp" :key="qIndex">
    <main id="content" :class="{'l-main': true, 'mode-reading': accountStore.isTtsEnabled, '-reading': readingPopup}" v-if="globalNavigationStore.selectedColor!=='' && currentQuestion">
      <!--Vertical layout-->
      <div v-if="globalNavigationStore.selectedColor==='kokugo'"
         class="p-question -kokugo p-question--vertical"
      >
        <question-information @click="stopQAModal=true" name="S3-7-close-btn">
          <template #chapterTitle>
            <button class="hamburger jsPopupButton" @click="skillModal=true" v-if="accountStore.isDebug">
              <span style="line-height: 1;">☰</span>
            </button>
            <markdown-view
                    :rawText="selectedQuestionSetTitle" :souruby="accountStore.isDebugSouruby"
                    :class="{'debug-markdown': accountStore.isDebug}">
            </markdown-view>
          </template>
          <template #chapterPageNumber v-if="selectedQuestionPageRange">
            <div class="c-parts-text-page -question">P {{selectedQuestionPageRange}}</div>
          </template>
          <template #chapterCorrectWrongList>
            <question-correct-wrong
                    :question-correct-wrong-list="getCorrectWrongList"
                    :position="qIndex">
            </question-correct-wrong>
          </template>
          <template #previousNextButton>
            <div class="previous-next-button" v-if="!workStore.isSearchQuestionById">
              <div class="button-frame">
                <a href="javascript:void(0)" class="prev" :class="{'-disabled':!qIndex}" @click="skipPrev" :tabindex="-1" name="S3-7-prev-skip-btn"><span>前へ</span></a>
                <span class="delimiter"></span>
                <a href="javascript:void(0)" class="next" @click="skipNext" :tabindex="-1" name="S3-7-next-skip-btn"><span>次へ</span></a>
              </div>
            </div>
          </template>
        </question-information>
        <div class="p-question__inner" ref="refModQuestionInner">
          <div class="p-question__main">
            <div class="c-reading">
              <button class="c-button-white -vertical-reading js-reading-open" @click="openReadingModal('markdownBodyVertical')" name="S3-7-read-text-btn">
                <span class="label">
                  読み上げ
                </span>
              </button>
            </div>
            <div class="p-question__body">
              <div class="p-question__body__question" @touchend="touchDeviceTextSelection">
                <markdown-view
                      id="markdownBodyVertical"
                      :rawText="currentQuestion.text"
                      :workId="currentQuestion.work_id" :souruby="accountStore.isDebugSouruby" :class="{'debug-markdown': accountStore.isDebug}">
                </markdown-view>
              </div>
            </div>
            <question-status
                tag-position="sideRight"
                :tag-label="getQuestionLabels" :tag-correct="getTagCorrect"
                :is-tag-review-required="!getReviewTag"
                @click="">
              <template #prevButton v-if="qIndex!==0">
                <a href="javascript:void(0)" class="prevBtn" @click="prevQuestion()" tabindex="-1" name="S3-7-prev-question-btn">
                  <div class="prevBtn__inner"></div>
                </a>
              </template>
            </question-status>
          </div>
          <quiz-area
            :is-vertical="true"
            :isDebugSouruby="accountStore.isDebugSouruby"
            :key="qIndex"
            :question-index="qIndex"
            @body-height="questionBodyHeight()"
            @go-next="goNext"
          >
            <template #helpTag>
              <question-help
                      @click="openModal($event)"
                      tag-position="sideLeft"
                      :is-hint="!!currentQuestion.hint"
                      :is-point="!!getPoint(currentQuestion.section_id)"
                      page-name="S3-7"
              ></question-help>
            </template>
            <template #report>
              <br>
              <a class="reportLink" @click="reportModal=true">問題の誤り・不具合を報告</a>
            </template>
          </quiz-area>
        </div>
      </div>

      <!--Horizontal layout-->
      <div v-else
        :class="['p-question p-question--horizontal -'+ globalNavigationStore.selectedColor]">
        <question-information @click="stopQAModal=true" name="S3-7-close-btn">
          <template #chapterTitle>
            <button class="hamburger jsPopupButton" @click="skillModal=true" v-if="accountStore.isDebug">
              <span style="line-height: 1;">☰</span>
            </button>
            <markdown-view
                    :rawText="selectedQuestionSetTitle" :souruby="accountStore.isDebugSouruby"
                    :class="{'debug-markdown': accountStore.isDebug}">
            </markdown-view>
          </template>
          <template #chapterPageNumber v-if="selectedQuestionPageRange">
            <div class="c-parts-text-page -question">P {{selectedQuestionPageRange}}</div>
          </template>
          <template #chapterCorrectWrongList>
            <question-correct-wrong
                :question-correct-wrong-list="getCorrectWrongList"
                :position="qIndex">
            </question-correct-wrong>
          </template>
          <template #previousNextButton>
            <div class="previous-next-button" v-if="!workStore.isSearchQuestionById">
              <div class="button-frame">
                <a href="javascript:void(0)" class="prev" :class="{'-disabled':!qIndex}" @click="skipPrev" :tabindex="-1" name="S3-7-prev-skip-btn"><span>前へ</span></a>
                <span class="delimiter"></span>
                <a href="javascript:void(0)" class="next" @click="skipNext" :tabindex="-1" name="S3-7-next-skip-btn"><span>次へ</span></a>
              </div>
            </div>
          </template>
        </question-information>
        <div class="p-question__main" id="jsQuestionHorizontal">
          <question-status
              tag-position="sideLeft"
              :tag-label="getQuestionLabels" :tag-correct="getTagCorrect"
              :is-tag-review-required="!getReviewTag"
              @click="">
          </question-status>
          <div class="c-reading">
            <button class="c-button-white -reading js-reading-open" @click="openReadingModal('markdownBodyHorizontal')" name="S3-7-read-text-btn">
              <span class="label">
                読み上げ
              </span>
            </button>
          </div>
          <div class="p-question__body" ref="refModQuestionBody">
            <div class="p-question__body__question" @touchend="touchDeviceTextSelection">
              <markdown-view 
                    id="markdownBodyHorizontal"
                    :class="{'debug-markdown': accountStore.isDebug}"
                    :rawText="currentQuestion.text"
                    :workId="currentQuestion.work_id" :souruby="accountStore.isDebugSouruby">
              </markdown-view>
            </div>
          </div>
          <question-help
                  @click="openModal($event)"
                  tag-position="sideRight"
                  :is-hint="!!currentQuestion.hint"
                  :is-point="!!getPoint(currentQuestion.section_id)"
                  page-name="S3-7"
          ></question-help>
        </div>
        <quiz-area
            :isDebugSouruby="accountStore.isDebugSouruby"
            :key="qIndex"
            :question-index="qIndex"
            @body-height="questionBodyHeight()"
            @go-next="goNext"
        >
          <template #prevButton v-if="qIndex!==0">
            <a href="javascript:void(0)" class="prevBtn" @click="prevQuestion()" tabindex="-1" name="S3-7-prev-question-btn">
              <div class="prevBtn__inner"></div>
            </a>
          </template>
          <template #report>
            <a class="reportLink" @click="reportModal=true">問題の誤り・不具合を報告</a>
          </template>
        </quiz-area>
      </div>

      <!--Stop question answer confirmation modal-->
      <popup-modal v-model="stopQAModal" @close="stopQAModal=false" @close-layer="stopQAModal=false" name="S3-7-close-learning-btn">
        <template #main>
          <div class="c-popup-body__head">
            <p class="c-popup-body__head-title">
              学習を中断しますか？
            </p>
          </div>
          <div class="c-popup-body__titleBox">
            <div class="c-popup-body__titleBox-logout u-text-caution" v-if="workStore.isReviewQuestion || workStore.isPrevQuestionHistory || (workStore.mission !== null && workStore.mission.kind !== missionKind.NEW)">
              学習を中断した場合，ここまでの解答は<br>学習記録に残りませんので，ご注意ください。
            </div>
            <div class="c-popup-body__titleBox-logout" v-else>
              中断した場合は、その続きから再開することができます。
            </div>
          </div>
        </template>
        <template #footer>
          <div class="c-button -col2">
            <a @click="stopQAModal=false" name="S3-7-continue-learning-btn" class="c-button-white -medium -font-large">
              <span class="label">中断せず学習を続ける</span>
            </a>
            <button-blue @click="closeModal('stopAQModal')" :medium="true" :label-normal="true" name="S3-7-stop-learning-btn">学習を中断する</button-blue>
          </div>
        </template>
      </popup-modal>

      <!-- この項目のポイント -->
      <popup-modal v-model="pointModal" @close="closeModal('point')" @close-layer="pointModal=false"
        :is-point-hint-modal="true"
        name="S3-7-point-close-btn"
        :modal-position-vertical="globalNavigationStore.selectedColor==='kokugo'"
      >
        <template #main>
          <div class="pointBlock">
            <div class="fixed-title-area">
              <div class="title">この項目のポイント</div>
              <div class="button">
                <button :class="{'c-button-white js-reading-open': true, '-reading': globalNavigationStore.selectedColor!=='kokugo', '-vertical-reading': globalNavigationStore.selectedColor==='kokugo'}" @click="openReadingModal('markdownPoint')" name="S3-7-read-point-text-btn">
                  <span class="label">
                    読み上げ
                  </span>
                </button>
              </div>
            </div>
            <div class="text" @touchend="touchDeviceTextSelection">
              <markdown-view
                      id="markdownPoint"
                      :class="{'debug-markdown': accountStore.isDebug}"
                      :rawText="getPoint(currentQuestion.section_id)"
                      :workId="currentQuestion.work_id" :souruby="accountStore.isDebugSouruby">
              </markdown-view>
            </div>
          </div>
        </template>
      </popup-modal>

      <!-- ヒント -->
      <popup-modal v-model="hintModal" @close="closeModal('hint')" @close-layer="hintModal=false"
         :is-point-hint-modal="true"
         name="S3-7-hint-close-btn"
         :modal-position-vertical="globalNavigationStore.selectedColor==='kokugo'"
      >
        <template #main>
          <div class="hintBlock">
            <div class="fixed-title-area">
              <div class="title">ヒント</div>
              <div class="button">
                <button :class="{'c-button-white js-reading-open': true, '-reading': globalNavigationStore.selectedColor!=='kokugo', '-vertical-reading': globalNavigationStore.selectedColor==='kokugo'}" @click="openReadingModal('markdownHint')" name="S3-7-read-hint-text-btn">
                  <span class="label">
                    読み上げ
                  </span>
                </button>
              </div>
            </div>
            <div class="text" @touchend="touchDeviceTextSelection">
              <markdown-view
                      id="markdownHint"
                      :class="{'debug-markdown': accountStore.isDebug}"
                      :rawText="currentQuestion.hint"
                      :workId="currentQuestion.work_id" :souruby="accountStore.isDebugSouruby">
              </markdown-view>
            </div>
          </div>
        </template>
      </popup-modal>
      <!--Skill modal-->
      <popup-modal v-model="skillModal" @close="skillModal=false" @close-layer="skillModal=false" :is-help-modal="true">
        <template #main>
          <div class="topNoticeBlock">
            <div class="text">
              スキル: {{allSkills()}}
            </div>
            <div class="text" v-if="getCheckFormulaAsString.length">
              答えを文字列一致のみで判定する
              <ul>
                <li v-for="(quiz,index) in getCheckFormulaAsString">
                  解答欄{{index+1}}<span v-if="quiz.label">({{quiz.label}})</span> : <span v-if="quiz.body.checkFormulaAsString">有効</span><span v-else>無効</span>
                </li>
              </ul>
            </div>
            <div class="text">
              解答形式
              <ul>
                <li v-for="(quiz,index) in getAnswerFormat">
                  解答欄{{index+1}}<span v-if="quiz.label">({{quiz.label}})</span> : <span>{{quiz.answer_format}}</span>
                </li>
              </ul>
            </div>
            <div class="text">
              <div>総ルビ表示の設定:</div>
              <div class="c-parts-toggle" :class="{'c-parts-toggle--active': accountStore.isDebugSouruby}" @click="toggleRubySwitch()">
                <span class="label">{{accountStore.isDebugSouruby?'ON':'OFF'}}</span>
                <span class="toggle"></span>
              </div>
            </div>
          </div>
        </template>
      </popup-modal>
      <!-- report modal -->
      <error-report-modal 
        v-model="reportModal"
        sid="S3-7" 
        :subject="subject_field"
        :qid="`${currentQuestion.work_id}-${currentQuestion.id}`"
        :uid="`user ${accountStore.userId}`"
        :workname="workStore.selectedWork[workStore.selectedWorkIndex].name"
        :qcode="currentQuestion.code" 
        :ucid="`${accountStore.studentProfile.profile.classroom.id}`"
        :usid="`${accountStore.studentProfile.profile.school.id}`"
        @close="reportModal=false" 
        @close-layer="reportModal=false">
      </error-report-modal>
      <!-- reading modal -->
      <reading-modal v-model="readingPopup" :subject-field="subject_field" :html-text="htmlText" :is-selection="isSelection" @close-layer="readingPopup=false" @close="readingPopup=false"></reading-modal>
    </main>
  </div>
</template>

<script setup lang="ts">
  import {ref, computed, onMounted, onUnmounted, nextTick, watch} from 'vue';
  import {useRoute, useRouter} from "vue-router"
  import {event} from "vue-gtag"
  import AudioPlayer from '@/consts/sounds';
  import {QUIZTYPE, QUIZTYPE_NAME} from '@/consts/answer_column';
  import {MISSIONKIND_SORT} from "@/consts/mission";
  import remove_markdown from "@/util/remove_markdown";
  import { isEnvCaptureGoogleAnalyticsEvents } from "@/util/env"
  import hideMiniContextMenuOnEdge from "@/util/diabled-context-menu"
  import { useAccountStore } from '@/store/student/account_store';
  import { useWorkStore } from '@/store/student/work_store';
  import { useGlobalNavigationStore } from '@/store/student/global_navigation_store';
  import { useHomeworkStore } from '@/store/student/homework_store';
  import local_time from "@/util/datetime";
  import getCsrfTokenFromCookie from "@/util/csrf-token";
  
  const audioPlayer = AudioPlayer.getInstance()
  const accountStore = useAccountStore()
  const workStore = useWorkStore()
  const globalNavigationStore = useGlobalNavigationStore()
  const route = useRoute()
  const router = useRouter()
  const refModQuestionInner = ref(null)
  const refModQuestionBody = ref(null)
  const stopQAModal = ref(false)
  const skillModal = ref(false)
  const pointModal = ref(false)
  const hintModal = ref(false)
  const reportModal = ref(false)
  const readingPopup = ref(false)
  // save the html content for reading modal
  const htmlText = ref('')
  // for store the reading text is selection or whole
  const isSelection = ref(false)
  const touchSelection = ref({
    "container": null,
    "text": null,
    "clone_content": null
  })
  const missionKind = MISSIONKIND_SORT
  // copy store question_index to local variable
  const qIndex = ref(workStore.questionIndex)
  const subject_field = workStore.selectedWork[workStore.selectedWorkIndex].subject_field

  onMounted(() => {
    // 内側のスクロール動きのため外側(body)スクロールを禁止する（ipadの不具合）
    let body_tag = document.getElementsByTagName('body')[0]
    body_tag.classList.add("unscrollable")
    if(accountStore.isDebug){
      accountStore.saveDebugSouruby(true)
    }
    else{
      accountStore.saveDebugSouruby(accountStore.isSouruby)
    }
    window.addEventListener('pagehide', onPageHide, false);
    window.history.pushState({}, null, null);
    window.addEventListener('popstate', browserBackHandler)
    window.addEventListener('resize', questionBodyHeight)
    if(qIndex.value == 0){
      workStore.saveQuestionStudyStartTime()
    }
    setDocumentTitle()
  })
  function setDocumentTitle() {
    if(workStore.isReviewQuestion){
      document.title = "要復習問題" + (qIndex.value + 1) + " | "
          + remove_markdown(workStore.selectedWork[workStore.selectedWorkIndex].name)
    }else{
      document.title = workStore.questions[qIndex.value]?.sort_order + " | "
          + remove_markdown(selectedQuestionSetTitle.value)+ " | "
          + remove_markdown(workStore.selectedWork[workStore.selectedWorkIndex].name)
    }
  }
  onUnmounted(() => {
    window.removeEventListener('pagehide', onPageHide, false)
    window.removeEventListener('popstate', browserBackHandler, false)
    window.removeEventListener('resize', questionBodyHeight, false)
    // delete virtual keyboard before change route NFR-2684
    document.querySelectorAll(".ML__keyboard").forEach(keyboard => keyboard.remove());
  })
  // NFR-5990: make a computed property for current question so every changes in question index will reflect in current question
  const currentQuestion = computed(() => {
    // if question is loaded and current question is present then return the current question
    if (workStore.questions.length > 0 && qIndex.value < workStore.questions.length) {
      return workStore.questions[qIndex.value];
    }
    // if question is not loaded or current question is not present then return null
    return null;
  });
  const getCorrectWrongList = computed(() => {
    return workStore.questionCorrectWrongList
  })
  const selectedWorkId =  workStore.selectedWork[workStore.selectedWorkIndex]?.id
  const selectedQuestionSetTitle = computed(() => {
    if(workStore.isSearchQuestionById){
      for(let section of workStore.sections){
        if(section.id==workStore.questions[qIndex.value].section_id){
          for(let question_set of section.question_sets){
            if(question_set.id == workStore.questions[qIndex.value].question_set_id){
              return question_set.title
            }
          }
        }
      }
      return ""
    }
    return workStore.selectedQuestionSet[workStore.questions[qIndex.value]?.question_set_id]?.title || ""
  })
  const selectedQuestionPageRange = computed(() => {
    // NFR-5754: save the current learning question
    const selectedQuestion = workStore.questions[qIndex.value]
    if(selectedQuestion) {
      if(selectedQuestion.textbook_startpage === '0' || selectedQuestion.textbook_endpage === '0'){
        return ''
      } 
      else if(selectedQuestion.textbook_startpage === selectedQuestion.textbook_endpage){
        return selectedQuestion.textbook_startpage;
      } 
      else {
        return `${selectedQuestion.textbook_startpage}-${selectedQuestion.textbook_endpage}`
      }
    } else {
      return ''
    }
  })
  const getQuestionLabels = computed(() => {
    // NFR-5867: if question is loaded and current question is present then return the question labels
    if(workStore.questions.length > 0 && workStore.questions[qIndex.value]){
      return workStore.questions[qIndex.value].question_labels.map(item => item.name)
    } else {
      return []
    }
  })
  const getReviewTag = computed(() => {
    let tag = workStore.reviewTags.filter(item =>
        item.question.id == workStore.questions[qIndex.value].id
    )
    if(tag.length>0){
      return true
    }
    else{
      return false
    }
  })
  const getTagCorrect = computed(() => {
    const question = workStore.questions[qIndex.value]
    if(question){
      let is_correct = workStore.questionProgress[question.id]
      if(!!is_correct){
        return is_correct.is_done_correctly
      }
      else{
        return false
      }
    }
    else{
      return false
    }
  })

  const getCheckFormulaAsString = computed(() => {
    return workStore.questions[qIndex.value].quizzes.filter(quiz =>{
      return quiz.answer_format === QUIZTYPE.DESCRIPTION || quiz.answer_format == QUIZTYPE.WRITTEN_RANDOM_ORDER
    })
  })
  const getAnswerFormat = computed(() => {
    return workStore.questions[qIndex.value].quizzes.map(quiz =>{
      return {
        label: quiz.label,
        answer_format: QUIZTYPE_NAME[quiz.answer_format]
      }
    })
  })
  const abortStudyLog = (action: string) => {
    const logData = {
      "abort_action" : action,
      "work_id" : selectedWorkId,
      "question_code": workStore.questions[qIndex.value]?.code || null,
      "question_start_datetime": workStore.start_date,
      "question_abort_datetime": local_time()
    }
    const jsonData = {
      'token' : getCsrfTokenFromCookie(document.cookie),
      'log' : logData
    }
    const headers = {
      type: 'application/json',
    };
    const blob = new Blob([JSON.stringify(jsonData)], headers);
    return blob
  }
  function getPoint(section_id){
    let section = workStore.sections.filter(item => item.id == section_id)
    if(section.length>0){
      return section[0].point
    }
    else{
      return ""
    }
  }
  function allSkills(){
    return workStore.questions[qIndex.value].skills.map(item => item.name).join(', ')
  }
  function toggleRubySwitch(){
    accountStore.saveDebugSouruby(!accountStore.isDebugSouruby)
  }
  function openModal(modal){
    if(modal == 'hint'){
      hintModal.value = true
      if(isEnvCaptureGoogleAnalyticsEvents()){
        event('show_hint', {
          'work_id': selectedWorkId,
          'question_id': workStore.questions[qIndex.value].id,
          'question_index': qIndex.value + 1
        })
      }
    }
    else if(modal == 'point'){
      pointModal.value = true
      if(isEnvCaptureGoogleAnalyticsEvents()){
        event('show_quesion_point', {
          'work_id': selectedWorkId,
          'question_id': workStore.questions[qIndex.value].id,
          'question_index': qIndex.value + 1
        })
      }
    }
  }
  function closeModal(modal){
    if(modal=='stopAQModal'){
      // setting study end time for current question
      workStore.saveQuestionStudyEndTime()
      // NFR-5116: swap study break data
      workStore.swapStudyBreakData('question')
      workStore.saveIsMissionQuestion(false)
      workStore.saveIsLearningPage(false)
      useHomeworkStore().saveIsHomework(false)
      if(accountStore.isSoundEnabled){audioPlayer.closeSound().play()}
      if(isEnvCaptureGoogleAnalyticsEvents()){
        navigator.sendBeacon('/student/api/log/abort_study', abortStudyLog("abort_button_click"));
        event('abort_study', {
          'work_id': selectedWorkId,
          'subject_field': subject_field,
          'question_id': workStore.questions[qIndex.value].id,
          'question_index': qIndex.value + 1,
          'screen_code': route.meta.screenCode,
          'abort_action': "abort_button_click"
        })
      }
      router.push({path:!!workStore.learningStartPage?workStore.learningStartPage.path:'/student/'}).then(async() => {
        workStore.saveIsSearchQuestionById(false)
        workStore.saveIsLearningMode(false)
      })
    }
    else if(modal == 'hint'){
      hintModal.value = false
    }
    else if(modal == 'point'){
      pointModal.value = false
    }
  }
  function onPageHide(evt: Event): void {
    // NFR-5116: swap study break data
    workStore.swapStudyBreakData('question')
    const question = workStore.questions[qIndex.value]
    if(isEnvCaptureGoogleAnalyticsEvents()){
      navigator.sendBeacon('/student/api/log/abort_study', abortStudyLog("window_unload"));
      event('abort_study', {
        'work_id': selectedWorkId,
        'subject_field': subject_field,
        'question_id': question?.id,
        'question_index': qIndex.value + 1,
        'screen_code': route.meta.screenCode,
        'abort_action': "window_unload"
      })
    }
  }
  function browserBackHandler(evt: PopStateEvent): void{
    window.history.pushState({}, null, null);
    stopQAModal.value = true
  }

  function prevQuestion(){
    let prevCorrectWrong = workStore.questionCorrectWrongList[qIndex.value-1]
    // if previous question answer is skip the route to S3-7
    if(prevCorrectWrong.progress == 1 && prevCorrectWrong.result == null){
      workStore.saveQIdx(qIndex.value - 1)
      qIndex.value--
      setDocumentTitle()
      questionBodyHeight()
    }
    else{
      workStore.saveQIdx(qIndex.value - 1)
      router.push({name:'answer'})
          .then(() => {
            workStore.saveIsPrevQuestionAnswerButton(true)
          })
          .catch(()=>{})
    }
  }

  function questionBodyHeight() {
    nextTick(() => {
      if (globalNavigationStore.selectedColor == 'kokugo') {
        let headerH = document.getElementsByClassName("p-question__header")[0].clientHeight;
        let mainBoxH = document.documentElement.clientHeight;
        let questionInnerH: any = refModQuestionInner.value
        questionInnerH.style.height = (mainBoxH - headerH) + 'px';
      } else {
        let mainBoxH = document.documentElement.clientHeight;
        let headerH = document.getElementsByClassName("p-question__header")[0].clientHeight;
        let footerH = document.getElementsByClassName("p-question__footer")[0].clientHeight;
        let questionBodyH: any = refModQuestionBody.value
        questionBodyH.style.height = (mainBoxH - headerH - footerH - 85) + 'px';
      }
      // NFR-5614: enable scroll to the bottom of a column
      const _modQuestion = document.getElementsByClassName("modQuestion__body__inner");
      // 段組がない場合は処理をしない
      if(!_modQuestion){
        return false;
      }
      for(let i = 0; i < _modQuestion.length; i++){
        const _this: any = _modQuestion[i];
        const _prev = _this.previousElementSibling;
        const _main = document.querySelector('.p-question__body__question');
        if(!_main){
          return false;
        }
        // 横書きの場合
        if (document.getElementById('jsQuestionHorizontal')) {
          let _prevH; // 前の要素の高さ

          // 前の要素がない場合は処理をしない
          if(!_prev){
            return false;
          } else {
            _prevH = _prev.clientHeight;
          }
          // .p-question__mainの高さを取得
          const _mainH = _main.clientHeight;
          // 前の要素の高さが問題文エリア60%より小さい場合のみ、段組に幅を設定する
          if(_prevH < (_mainH * 0.6)){
            _this.style.height = "calc(100% + 10px - " + _prevH + "px)";
          }
        // 縦書きの場合
        } else {
          let _prevW; // 前の要素の横幅

          // 前の要素がない場合は横幅100%にする
          if(!_prev){
            _prevW = 0;
          } else {
            _prevW = _prev.clientWidth;
            // スタイル属性にpadding-leftを追加
            _this.style.paddingLeft = "40px";
          }

          // .p-question__mainの横幅を取得
          const _mainW = _main.clientWidth;
          // 前の要素の幅が問題文エリア40%より小さい場合のみ、段組に幅を設定する
          if(_prevW < (_mainW * 0.4)){
            _this.style.width = "calc(100% - 20px - " + _prevW + "px)";
          } else {
            _this.style.width = "100%";
          }
        }
      }
    })
  }
  // go to next route S3-8 or S3-9
  function goNext(name){
    router.push({name: name}).catch(()=>{})
  }
  /**
   * This is a function name 'skipNext' which skip the current question and go to next one
   */
  function skipNext(){
    // NFR-5891: setting study end time for current question
    workStore.saveQuestionStudyEndTime()
    const nextIndex = qIndex.value + 1
    // save the current question as a skip state
    workStore.saveSingleQuestionCorrectWrongList({result: null, progress: 1})
    // check next question is last one
    if(workStore.questionIds.length == nextIndex){
      // if all question are skip then return to learning start page
      let skipAll = workStore.questionCorrectWrongList.every(item => item.progress==1 && item.result==null)
      if(skipAll){
        // delete study break data
        workStore.deleteStudyBreakData()
        workStore.saveIsLearningPage(false)
        // stop animation in top page for skip all question
        workStore.saveIsMissionQuestion(false)
        let path = !!workStore.learningStartPage?workStore.learningStartPage.path:null
        // stop animation for chapter and work page
        workStore.saveLearningStartPage(null)
        // avoid page error
        if(path){
          router.push({path:path}).then(()=> workStore.saveIsLearningMode(false))
        }
      }
      else {
        // if any question is answered then go to S3-10 modal. Here queryparams p=skip indicate go to final modal from S3-9 page initialize
        router.push({name: 'answer', query: {p:"skip"}}).catch(() => {})
      }
    }
    // next question is already answered the go to S3-9 page 
    else if(nextIndex < workStore.questionCorrectWrongList.length && workStore.questionCorrectWrongList[nextIndex]?.progress==1 && workStore.questionCorrectWrongList[nextIndex]?.result!=null){
      workStore.saveQIdx(nextIndex)
      router.push({name: 'answer'}).catch(() => {})
    }
    // skip current question and go to next question S3-7 page 
    else {
      workStore.saveQIdx(nextIndex)
      qIndex.value++
      // setting study start time for next question
      workStore.saveQuestionStudyStartTime()
      setDocumentTitle()
      questionBodyHeight()
    }
  }
  /**
   * This is a function name 'skipPrev' which go to previous question based on condition
   */
  function skipPrev(){
    const prevIndex = qIndex.value - 1;
    if (prevIndex >= 0 && prevIndex < workStore.questionCorrectWrongList.length) {
      // if previous question is skip state then go to S3-7 for previous question
      if(workStore.questionCorrectWrongList[prevIndex].progress==1 && workStore.questionCorrectWrongList[prevIndex].result==null){
        workStore.saveQIdx(prevIndex)
        // setting study start time for prev question
        workStore.saveQuestionStudyStartTime()
        // as current page is S3-7 so decrease question_index and set title and bodyheight for previous question 
        qIndex.value--
        setDocumentTitle()
        questionBodyHeight()
      }
      // for previous question is already answered then go to  S3-9 for previous question
      else {
        workStore.saveQIdx(prevIndex)
        router.push({name: 'answer'}).catch(() => {})
      }
    }
  }
  // collecting whole body or point or hint dom element
  function openReadingModal(element: string){
    htmlText.value = ''
    isSelection.value = false
    const markdownElement = document.getElementById(element)
    // get current selection
    let selection = window.getSelection()
    // check the selection come from iPad or not
    if(!selection.toString() && touchSelection.value.text){
      if(markdownElement && markdownElement.contains(touchSelection.value.container)){
        const container = document.createElement('div');
        container.appendChild(touchSelection.value.clone_content)
        htmlText.value = container.outerHTML
        isSelection.value = true
        touchSelection.value = {
          "container": null,
          "text": null,
          "clone_content": null
        }
        readingPopup.value = true
        return
      }
    }
    if(markdownElement){
      // if any selected item inside question body, point, hint then convert selected part only
      if(selection.rangeCount > 0){
        const range = selection.getRangeAt(0);
        if(selection.toString().length > 0 && markdownElement.contains(range.commonAncestorContainer)){
          const container = document.createElement('div');
          container.appendChild(range.cloneContents());
          htmlText.value = container.outerHTML
          isSelection.value = true
        } else {
          htmlText.value = markdownElement.outerHTML 
        }
      } else {
        htmlText.value = markdownElement.outerHTML
      }
    }
    readingPopup.value = true
  }
  // NFR-5562: to check selection is empty or not
  function isSelectionEmpty(selection: Selection) {
    // Check if there's any selection range
    if (!selection || selection.rangeCount === 0) {
      return true;
    }
    // Check if the range is collapsed (i.e., no text is selected)
    return selection.isCollapsed;
  }
  // handle touch device text-selection and save it to component variable
  function touchDeviceTextSelection() {
    setTimeout(() => {
      const selection = window.getSelection()
      if(!isSelectionEmpty(selection)){
        const range = selection.getRangeAt(0);
        touchSelection.value = {
          "container": range.commonAncestorContainer,
          "text": selection.toString(),
          "clone_content": range.cloneContents()
        }
      }
    }, 0);
  }
  function preventContextmenu(event:Event){
    // NFR-4573, if student is not debug mode then disabled context menu
    if(!accountStore.isDebug){
      event.preventDefault()
    }
  }
  function preventCopy(event:Event){
    // NFR-4573, if student is not debug mode then disabled CTRL + c to copy text
    if(!accountStore.isDebug){
      event.preventDefault()
    }
  }
  function handleMouseUp() {
    // NFR-4573, if student is not debug mode then disabled Edge browser mini-context menu
    if(!accountStore.isDebug){
      hideMiniContextMenuOnEdge()
    }
  }
  // NFR-5267 storeのquestionIndexの変化を監視してqIndexを更新
  watch(() => workStore.questionIndex, (newIndex) => {
    qIndex.value = newIndex;
  });
</script>
